var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg033FastForward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fill: "current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M494.468,213.588c-0.035-0.035-0.071-0.071-0.107-0.106L338.391,59.773c-17.481-17.439-42.504-22.401-65.324-12.954 c-22.855,9.461-37.052,30.704-37.052,55.439v89.215L102.375,59.772C84.894,42.333,59.872,37.371,37.051,46.818 C14.197,56.28,0,77.523,0,102.259v307.483c0,24.734,14.197,45.979,37.051,55.44c7.653,3.169,15.554,4.717,23.334,4.716 c15.424,0,30.378-6.082,41.997-17.678l133.631-131.684v89.205c0,24.772,14.168,46.027,36.975,55.469 c7.599,3.146,15.446,4.684,23.18,4.683c15.414,0,30.373-6.104,41.999-17.737c7.808-7.813,7.803-20.478-0.011-28.287 c-7.811-7.808-20.477-7.802-28.286,0.011c-8.727,8.731-18.724,5.554-21.58,4.371c-2.879-1.192-12.274-6.05-12.274-18.51V102.259 c0-12.403,9.453-17.28,12.351-18.48c2.896-1.2,13.032-4.431,21.798,4.342c0.036,0.035,0.072,0.071,0.109,0.107l155.943,153.681 c7.732,7.781,7.736,20.396,0.01,28.183l-87.216,85.644c-7.882,7.74-7.997,20.403-0.258,28.285 c7.74,7.883,20.404,7.998,28.285,0.258l87.296-85.722c0.045-0.044,0.089-0.088,0.133-0.132 C517.844,275.034,517.844,236.978,494.468,213.588z M230.206,270.099l-86.296,85.038L74.26,423.77l-0.109,0.109 c-8.767,8.771-18.901,5.542-21.798,4.341c-2.897-1.199-12.35-6.076-12.35-18.479V102.259c0-12.403,9.453-17.28,12.351-18.48 c1.364-0.565,4.334-1.581,8.012-1.581c4.129,0,9.15,1.282,13.787,5.923c0.036,0.035,0.072,0.071,0.109,0.107l155.942,153.681 C237.937,249.693,237.938,262.312,230.206,270.099z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg033FastForward);
export default __webpack_public_path__ + "static/media/033-fast-forward.1f2b096a5acfddcd1c11b2a5b91b7a00.svg";
export { ForwardRef as ReactComponent };